// extracted by mini-css-extract-plugin
export var tagContainer = "index-module--tagContainer--7ne1z";